<template>
  <b-card class="states-middle">
    <b-row class="form-title">
      <h3>
        {{ title }}
      </h3>
      <p>
        {{ description }}
      </p>
    </b-row>
    <b-container>
      <slot></slot>
    </b-container>
  </b-card>
</template>

<script>
export default {
  name: "input-container",

  props: {
    title: {
      type: String,
      required: true,
    },
    description: String,
  }
}
</script>

<style scoped>

</style>